import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {aboutData.title}
            </h2>
          </div>
          <div className="space-y-5">
            {aboutData.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}